<template>
  <v-app class="home">
    <v-layout mt-5>
      <v-flex xs12 md4 pa-2 offset-md4 class="text-xs-center">
        <v-text-field solo v-model="username" placeholder="Username"></v-text-field>
        <v-radio-group v-model="platform" row :style="{ display: 'inline-block' }">
          <v-radio
            label="XB1"
            :value="1"
          ></v-radio>
          <v-radio
            label="PS4"
            :value="2"
          ></v-radio>
          <v-radio
            label="PC"
            :value="4"
          ></v-radio>
        </v-radio-group><br>
        <v-btn @click="fetchUserData" :disabled="!(!!username && !!platform)"> Search </v-btn>
        <br> <br>
        <v-list two-line v-if="profiles.length > 0">
          <template v-for="(item, index) in profiles">
            <v-list-tile
              :key="index"
              avatar
            >
              <v-list-tile-content>
                <v-list-tile-title> {{ item.displayName }} </v-list-tile-title>
                <v-list-tile-sub-title>
                  Membership ID: {{ item.membershipId }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
               <v-btn icon @click="showUserData(item.displayName, item.membershipId)">
                 <v-icon> open_in_new </v-icon>
               </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <br>
        <v-list :hidden="recentSearches.length == 0" two-line>
          <span class="title font-weight-light"> Recent Searches </span>
          <template v-for="(item, index) in recentSearches">
            <v-list-tile
              :key="index"
              avatar
            >
              <v-list-tile-content>
                <v-list-tile-title> {{ item.name }} </v-list-tile-title>
                <v-list-tile-sub-title>
                  Membership ID: {{ item.id }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
               <v-btn icon @click="showUserDataFromHistory(item.name, item.id, item.platform)">
                 <v-icon> open_in_new </v-icon>
               </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4 pa-2>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
/* eslint-disable */
import axios from 'axios';

const toastOptions = {
  duration: 2500,
  position: 'bottom-center',
  action : {
    icon: 'close',
    onClick : (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
}

export default {
  name: 'Home',
  data() {
    return {
      username: null,
      platform: null,
      profiles: [],
      characters: null,
    };
  },
  computed: {
    users() {
      return this.$store.getters.users;
    },
    stats() {
      return this.$store.getters.stats;
    },
    recentSearches() {
      return this.$store.getters.recentSearches;
    },
  },
  methods: {
    async fetchUserData() {
      this.characters = null;
      await axios.get(`https://www.bungie.net/Platform/Destiny2/SearchDestinyPlayer/${this.platform}/${encodeURIComponent(this.username)}/?components=200`, {
        headers: { 'X-API-KEY': this.$store.state.apiKey }
      }).then((response) => {
        if (!response.data.Response) {
          this.$toasted.error(`We could not retrieve your stats at this time. Please try again.`, toastOptions);
          console.log(JSON.stringify(response.data));
        } else if (response.data.Response && response.data.Response.length === 0) {
          this.$toasted.error(`No users found for ${this.username}`, toastOptions);
        } else {
          response.data.Response.forEach(element => {
            this.profiles.push(element);
          });
        }
      }, (error) => {
        this.$toasted.error(`There was an issue communicating with the Bungie API. Please try again later.`, toastOptions);
      });
    },
    showUserData(name, id){
      this.$store.commit('SET_ACTIVE_USER', name);
      if (this.recentSearches.filter(search => search.id == id).length === 0) {
        this.$store.commit('SET_RECENT_SEARCHES', [{ name, id, platform: this.platform }, ...this.recentSearches]);
      }
      this.$router.push({ name: 'User', params: { id, platform: this.platform }})
    },
    showUserDataFromHistory(name, id, platform){
      this.$store.commit('SET_ACTIVE_USER', name);
      this.$router.push({ name: 'User', params: { id, platform }})
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css');
</style>



// WEBPACK FOOTER //
// src/components/Home.vue